(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-details-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  function closeAccordion(trigger, body) {
    trigger.setAttribute('aria-expanded', 'false');
    body.style.maxHeight = body.scrollHeight + 'px';
    requestAnimationFrame(function () {
      body.style.transition = 'max-height 0.25s ease';
      body.style.maxHeight  = '0';
    });
    body.addEventListener('transitionend', function onEnd() {
      body.setAttribute('hidden', '');
      body.style.maxHeight  = '';
      body.style.transition = '';
      body.removeEventListener('transitionend', onEnd);
    });
  }

  function openAccordion(trigger, body) {
    trigger.setAttribute('aria-expanded', 'true');
    body.removeAttribute('hidden');
    var h = body.scrollHeight;
    body.style.maxHeight  = '0';
    body.style.overflow   = 'hidden';
    requestAnimationFrame(function () {
      body.style.transition = 'max-height 0.25s ease';
      body.style.maxHeight  = h + 'px';
    });
    body.addEventListener('transitionend', function onEnd() {
      body.style.maxHeight  = '';
      body.style.transition = '';
      body.style.overflow   = '';
      body.removeEventListener('transitionend', onEnd);
    });
  }

  function initAccordions(wrapper) {
    // Separate left and right groups so they don't interfere with each other
    var leftAccordions  = Array.from(wrapper.querySelectorAll('.pd-left [data-accordion], .product-details-desktop-hide [data-accordion]'));
    var rightAccordions = Array.from(wrapper.querySelectorAll('.pd-right [data-accordion]'));

    function bindGroup(group) {
      group.forEach(function (accordion) {
        var trigger = accordion.querySelector('.pd-accordion__trigger');
        var body    = accordion.querySelector('.pd-accordion__body');
        if (!trigger || !body) return;

        trigger.addEventListener('click', function () {
          var isOpen = trigger.getAttribute('aria-expanded') === 'true';

          if (isOpen) {
            // Just close it
            closeAccordion(trigger, body);
          } else {
            // Close all others in the same group first
            group.forEach(function (other) {
              if (other === accordion) return;
              var otherTrigger = other.querySelector('.pd-accordion__trigger');
              var otherBody    = other.querySelector('.pd-accordion__body');
              if (otherTrigger && otherBody && otherTrigger.getAttribute('aria-expanded') === 'true') {
                closeAccordion(otherTrigger, otherBody);
              }
            });
            // Then open this one
            openAccordion(trigger, body);
          }
        });
      });
    }

    bindGroup(leftAccordions);
    bindGroup(rightAccordions);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.pd-wrapper').forEach(initAccordions);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
(() => {
  const installations = new WeakMap();
  const initialize = (scope) => {
    scope.querySelectorAll('slideshow-component[data-dm-banner-enabled="true"]').forEach((root) => {
      if (installations.has(root)) return;
      const slider = root.querySelector('.slideshow');
      const video = root.querySelector('.dm-banner-video');
      const videoSlide = root.querySelector('.dm-banner-slide');
      if (!slider || !video || !videoSlide || typeof root.play !== 'function') return;
      const controller = new AbortController();
      const options = { signal: controller.signal };
      const mobile = matchMedia('(max-width: 749px)');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const state = {
        active: false,
        visible: false,
        running: slider.dataset.autoplay === 'true' && root.autoplayButtonIsSetToPlay !== false,
        failed: false,
        blocked: false,
        timer: null
      };
      const clearTimer = () => {
        clearTimeout(state.timer);
        clearInterval(root.autoplay);
        state.timer = null;
      };
      const mayRotate = () => state.running && state.visible && !document.hidden && !reduced.matches;
      const mayPlay = () => state.active && state.visible && !document.hidden && !reduced.matches && root.autoplayButtonIsSetToPlay !== false && !state.failed && !state.blocked;
      const schedule = (delay) => {
        clearTimer();
        if (!mayRotate()) return;
        let wait = Number(slider.dataset.speed) * 1000 || 5000;
        if (state.active) {
          const remaining = Number.isFinite(video.duration) ? video.duration - video.currentTime : 16;
          wait = Math.max(500, remaining * 1000 + 350);
        }
        if (delay !== undefined) wait = delay;
        state.timer = setTimeout(() => {
          state.timer = null;
          if (mayRotate()) root.autoRotateSlides();
        }, wait);
      };
      const setSize = () => {
        root.style.setProperty('--dm-banner-height', `${slider.clientWidth * (mobile.matches ? 1200 / 900 : 900 / 1920)}px`);
      };
      const loadSelectedVideo = () => {
        const src = mobile.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
        video.poster = mobile.matches ? video.dataset.mobilePoster : video.dataset.desktopPoster;
        if (src && video.getAttribute('src') !== src) {
          video.dataset.ready = 'false';
          state.failed = false;
          state.blocked = false;
          video.src = src;
          video.muted = true;
          video.defaultMuted = true;
          video.load();
        }
      };
      const synchronizeVideo = () => {
        if (!mayPlay()) {
          video.pause();
          return;
        }
        loadSelectedVideo();
        if (!video.getAttribute('src') || !video.paused) return;
        const result = video.play();
        if (result && typeof result.catch === 'function') {
          result.catch((error) => {
            if (error.name === 'AbortError') return;
            state.blocked = true;
            video.dataset.ready = 'false';
            schedule();
          });
        }
      };
      const refresh = () => {
        const activeSlide = root.sliderItemsToShow && root.sliderItemsToShow[root.currentPage - 1];
        const wasActive = state.active;
        state.active = activeSlide === videoSlide;
        root.dataset.dmCurrent = String(state.active);
        setSize();
        if (state.active && !wasActive) {
          state.blocked = false;
          if (video.readyState > 0) video.currentTime = 0;
        }
        if (!state.active) video.pause();
        synchronizeVideo();
        schedule();
      };
      const originalPlay = root.play;
      const originalPause = root.pause;
      clearTimer();
      root.play = () => {
        state.running = true;
        slider.setAttribute('aria-live', 'off');
        schedule();
        synchronizeVideo();
      };
      root.pause = () => {
        state.running = false;
        slider.setAttribute('aria-live', 'polite');
        clearTimer();
      };
      root.addEventListener('slideChanged', refresh, options);
      const autoplayButton = root.querySelector('.slideshow__autoplay');
      if (autoplayButton) {
        autoplayButton.addEventListener('click', () => {
          queueMicrotask(() => {
            state.blocked = false;
            synchronizeVideo();
            schedule();
          });
        }, options);
      }
      video.addEventListener('playing', () => {
        if (!mayPlay()) {
          video.pause();
          return;
        }
        video.dataset.ready = 'true';
        schedule();
      }, options);
      video.addEventListener('waiting', () => {
        if (state.active) schedule(30000);
      }, options);
      video.addEventListener('error', () => {
        state.failed = true;
        video.dataset.ready = 'false';
        schedule();
      }, options);
      const observer = new IntersectionObserver((entries) => {
        state.visible = entries.some((entry) => entry.isIntersecting);
        synchronizeVideo();
        schedule();
      }, { threshold: 0.05 });
      observer.observe(slider);
      const resize = new ResizeObserver(setSize);
      resize.observe(slider);
      mobile.addEventListener('change', () => {
        video.pause();
        video.dataset.ready = 'false';
        state.blocked = false;
        setSize();
        synchronizeVideo();
        schedule();
      }, options);
      reduced.addEventListener('change', () => {
        if (reduced.matches) video.dataset.ready = 'false';
        synchronizeVideo();
        schedule();
      }, options);
      document.addEventListener('visibilitychange', () => {
        synchronizeVideo();
        schedule();
      }, options);
      const cleanup = () => {
        clearTimer();
        video.pause();
        observer.disconnect();
        resize.disconnect();
        controller.abort();
        root.play = originalPlay;
        root.pause = originalPause;
        installations.delete(root);
      };
      installations.set(root, cleanup);
      refresh();
    });
  };
  customElements.whenDefined('slideshow-component').then(() => initialize(document));
  document.addEventListener('shopify:section:load', (event) => {
    customElements.whenDefined('slideshow-component').then(() => initialize(event.target));
  });
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('slideshow-component').forEach((root) => installations.get(root)?.());
  });
})();


  } catch(e) { console.error(e); }
})();
})();
